import RFQRecipientGrid from './RFQRecipientGrid';

export default RFQRecipientGrid;



// WEBPACK FOOTER //
// ./src/components/grids/RFQRecipientGrid/index.jsx